import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["team", "logo"];

  setMessage(event) {
    var status_message = document.getElementById('status-message');
    var team_content = document.getElementById('team-content');
    var new_team = event.currentTarget.dataset.team;

    if (status_message.textContent.includes('Você escolheu o')) {
      if (status_message.classList.contains('hidden')) {
        status_message.classList.toggle('hidden');
        team_content.classList.toggle('hidden');
      }
      status_message.innerText = "Tem certeza que deseja alterar seu palpite para " + `${new_team}` + "?";
    }
    else if (status_message.textContent.includes('Tem certeza que deseja alterar')) {
      status_message.innerText = 'Você escolheu o';
      status_message.classList.toggle('hidden');
      team_content.classList.toggle('hidden');
      
      var original_team = this.teamTarget.value;
      var original_logo = this.logoTarget.value;

      document.getElementById('team-message').src = original_logo;
      document.getElementById('team-name').innerText = original_team;
    }
    else {
      status_message.innerText = 'Você ainda não confirmou seu palpite!';
    }

    new_team = '';
  }
}